export default "__VITE_ASSET__D67GP5mb__"